import {
  CustomsCodeSearchQuery,
  customsCodesApi,
} from '@texas/api/endpoints/metadata/customsCodesApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useActiveSession } from '@texas/hooks/useSession';
import { useEffect, useState } from 'react';

const defaultSearchQuery: CustomsCodeSearchQuery = {
  searchTerm: '',
  branchId: 0,
  includeArchived: false,
  sortBy: 'identifier',
  sortDesc: false,
  page: 1,
  pageSize: 50,
};

export function useCustomsCodes() {
  const { branches } = useActiveSession();
  const [query, setQuery] = useState(defaultSearchQuery);
  const { data, refetch, loading, error } = useApiResource(
    customsCodesApi.search,
  );

  useEffect(() => {
    refetch(query);
  }, [refetch, query]);

  return {
    branches,
    filter: query.searchTerm,
    branchId: query.branchId,
    includeArchived: query.includeArchived,
    loading,
    error,
    data: data?.items ?? [],
    sorted: {
      key: query.sortBy,
      desc: query.sortDesc,
      onSortedChange: ({ key, desc }: { key: string; desc: boolean }) =>
        setQuery((current) => ({
          ...current,
          sortBy: key,
          sortDesc: desc,
          page: 1,
        })),
    },
    pagination: {
      pageSize: query.pageSize,
      totalItems: data?.totalItems ?? 0,
      currentPage: query.page,
      onPageChange: (page: number) =>
        setQuery((current) => ({ ...current, page })),
    },
    setFilter: (searchTerm: string) =>
      setQuery((current) => ({ ...current, searchTerm, page: 1 })),
    setBranchId: (branchId: number) =>
      setQuery((current) => ({ ...current, branchId, page: 1 })),
    setIncludeArchived: (includeArchived: boolean) =>
      setQuery((current) => ({ ...current, includeArchived, page: 1 })),
  };
}
